export enum CommitteeSort {
  Code = 1,
  Town = 2,
  Name = 3,
  Status = 4,
  DateFrom = 5,
}
